import { useEffect } from 'react';
import { APP_NAME, titelText } from '@schnitt/shared';

/**
 * Setzt den Titel des Reiters, solange die Seite steht, und räumt ihn danach
 * wieder weg. Gerechnet wird er in `@schnitt/shared` (`titelText`,
 * `exportTitel`) — dort ist er prüfbar.
 */
export function useTitel(seite: string | null, vorn?: string | null): void {
  useEffect(() => {
    document.title = titelText(seite, vorn);
    return () => {
      document.title = APP_NAME;
    };
  }, [seite, vorn]);
}
